export default {
  REQUIRED: [(v) => !!v || 'generales.campoobligatorio'],
  REQUIRED_MULTIPLE: [(v) => (!!v && !!v.length) || 'generales.campoobligatorio'],
  EMAIL: [(v) => !!v || 'generales.campoobligatorio', (v) => /.+@.+\..+/.test(v) || 'generales.invalidoemail'],
  NUMBER: [(v) => Number.isInteger(Number(v)) || 'generales.requeridonumero'],
  DECIMAL: [(v) => v === null || v === undefined || v === '' || /^-?\d+([.,]\d+)?$/.test(String(v).trim()) || 'generales.requeridonumero'],
  //if is boolean, accept 0 and 1
  BOOLEAN: [(v) => v === 0 || v === 1 || v === false || v === true || 'generales.campoobligatorio'],
  //required but accept 0
  REQUIRED_NUMBER: [(v) => v === 0 || !!v || 'generales.campoobligatorio'],
}
